import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import IndependentResearcherFeed from "./IndependentResearcherFeed";
import IndependentResearcherRealWorldProblems from "./IndependentResearcherRealWorldProblems";
import { IndependentResearherProfile } from "./IndependentResearherProfile";
import IndustryProfiles from "./IndustryProfiles";
import UniversityAnnouncements from "./UniversityAnnouncements";

const IndependentResearcherHome = () => {
  const [urlParams, setUrlParams] = useSearchParams();
  // URL is source of truth
  const tabFromUrl = urlParams.get("tab") || "feed";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  // sync state → URL
  useEffect(() => {
    setUrlParams({ tab: activeTab });
  }, [activeTab]);

  // sync URL → state (for refresh/back/forward)
  useEffect(() => {
    setActiveTab(tabFromUrl);
  }, [tabFromUrl]);

  return (
    <div className="container mx-auto md:px-4 mt-6 mb-4">
      <div className="flex relative">
        {/* Left Profile */}
        <div className="hidden md:block w-1/4 px-2">
          <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
            <IndependentResearherProfile />
          </div>
        </div>

        {/* Center */}
        <div className="w-full md:w-2/4 md:px-2">
          <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">

            {/* Tabs */}
            <div className="flex gap-4 w-full pb-4">
              <button
                onClick={() => setActiveTab("feed")}
                className={`w-1/2 py-2 text-center ${
                  activeTab === "feed"
                    ? "bg-[#0f6abf] hover:bg-[#0a5ca8]"
                    : "bg-gray-200"
                } text-white rounded-[10px]`}
              >
                Feed
              </button>

              <button
                onClick={() => setActiveTab("opportunity")}
                className={`w-1/2 py-2 text-center ${
                  activeTab === "opportunity"
                    ? "bg-[#0f6abf] hover:bg-[#0a5ca8]"
                    : "bg-gray-200"
                } text-white rounded-[10px]`}
              >
                Opportunity
              </button>

              <button
                onClick={() => setActiveTab("announcement")}
                className={`w-1/2 py-2 text-center ${
                  activeTab === "announcement"
                    ? "bg-[#0f6abf] hover:bg-[#0a5ca8]"
                    : "bg-gray-200"
                } text-white rounded-[10px]`}
              >
                Announcements
              </button>
            </div>

            {/* Content */}
            {activeTab === "feed" && (
              <IndependentResearcherFeed
                activeTab={activeTab}
              />
            )}

            {activeTab === "opportunity" && (
              <IndependentResearcherRealWorldProblems />
            )}

            {activeTab === "announcement" && (
              <UniversityAnnouncements />
            )}
          </div>
        </div>

        {/* Right */}
        <div className="hidden md:block w-1/4 px-2">
          <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
            <IndustryProfiles />
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(IndependentResearcherHome);